// import { useAuth } from '../views/AuthProvider';
import { Outlet } from 'react-router';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { SANDBOX } from '../data/constantes';

export default function Layout() {
    // const { isAuthenticated, login, logout } = useAuth();
    // const navigate = useNavigate();

    // const handleLogout = () => {
    //     logout();
    //     navigate('/iniciar');
    // };

    return (
        <div className={`relative min-h-screen ${SANDBOX ? 'watermark-bg' : '' }`}>
            <Header />
            <main>
                <Outlet />
            </main>
            <Footer />
        </div>
    )
}
